import { Alert,Form,Col,Button, Fade } from "react-bootstrap";
import Scholarship from './Scholarship';
import SchRegisterStatus from './SchRegisterStatus';
import Programme from './Programme';
import BasicInfo from './BasicInfo';
import Qualification from './Qualification';
import OtherInfoHeader from './OtherInfoHeader';
import OtherInfoHeader2 from './OtherInfoHeader2';

import ContactReferee from "./ContactReferee";

import Essay from './Essay';
import MusicBackground from './MusicBackground';
import Sports from './Sports';
import Extracurricular from './Extracurricular';
import FamilyBackground from './FamilyBackground'
import SupportDocument from './SupportDocument';

import Declaration from './Declaration';
import ParentGuardian from './ParentGuardian';

import TermsAndConditions from './TermsAndConditions'
import Notification from "../common/Notification";

import { ApplicantContainer} from "../unstated/applicant";
import React, { useEffect } from "react";

import documents from "./data/SupportDocuments.json";
import DocumentType from "./data/DocumentType.json";
import { apiURL, ADULT_AGE, IGNORE_SUPPORT_DOC, INIT_DOCUMENTS_VALUES, RECAPTCHA_SITE_KEY } from "../config/common";
import dayjs from 'dayjs';

import { useHistory } from "react-router-dom";


function ShowErrorMsg({errorMsg, invalidMsg}) {
    let errCtr= 0;

    return (
    <>
    { Object.keys(errorMsg).length || invalidMsg === "invalid" ? (
    <Form.Row>                  
        <Col xs={12}>
        <Fade in={true}>
        <Alert variant="danger" >
            <ol>
        {errorMsg.map((err) =>                   
            
            <li key={errCtr++}>{err}</li>
            
        )}        
        </ol>
        </Alert>
        </Fade>
        </Col>
    </Form.Row>  
    )
    :('')}
    </>)
}



export default function Main() {

    useEffect(() => {

        const script = document.createElement("script");
        script.src ="https://www.google.com/recaptcha/api.js?render=" + RECAPTCHA_SITE_KEY;
        document.body.appendChild(script);
    
    }, [])

    const [modalShow, setModalShow] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const [spinner, setShowSpinner] = React.useState(true);
    const [closeButton, setShowCloseButton] = React.useState(false);

    const history = useHistory();

    let app = ApplicantContainer.useContainer();
    
    let InStdValues = app.inStdValues;

    let [invalidMsg, setInvalidMsg] = React.useState('valid');


    function updInvalidMsgCB(msg) {
        setInvalidMsg(msg);
  
    }

    const handleReset = async (event) => {
  
        app.setError([]);
        app.setValidate(false);

        setInvalidMsg('valid');
      

        app.onChangeDocuments({...INIT_DOCUMENTS_VALUES});
        app.onChangeInStdValues({applicant_id: '',
        frScholarship: '',
        frProgramme: '', 
        frIntake: '', 
        frName: '', 
        frICPassport: '', 
        frEmail: '', 
        frMobileNo: '', 
        frDOB: '', 
        frDateOfBirth: '', 
        frHomeAddr: '',
        frPGConsentName: '', 
        frPGConsentICPassport: '', 
        frDeclarations: false, 
        invalidMsg:'valid',
        frEssay:'',
        frContactReferee:[{ sname: '', affiliation: '', position: '', email: '' }],
        frVideoURL:'',
        frPortfolioURL:'',
        frExtracurricularLeadership: [{ LeaderYear: '', LeaderName: '', LeaderPosition: '' }],
        frExtracurricularCompete: [{ CompeteYear: '', CompeteName: '', CompeteResult: '' }],
        frExtracurricularAward: [{ AwardYear: '', AwardName: '' }],
        frExtracurricularOther: [{ AwardYear: '', AwardName: '' }],
        frMusic:[{ InstrumentPlayed: '', MusicGrade: '' }],      
        frSports:[{ SportLevel: '', SportType: '', SportPeriod: '', SportRemark: '' }],
        frQualification:[{highest: true, qualification: '', grade: ''}],
        frParentGuardian:{ frCCParentChoiceOne: '', frCCParentNameOne: '', frCCParentICPasportOne: '', frParentCCAgeOne: '', frCCParentStatusOne: '', 
                frCCParentEmployTypeOne: '', frCCParentOccupationOne: '', frCCParentWorkAddrOne: '', frCCParentIncomeOne: '', frCCParentOtherIncomeOne: '',                    
                frCCParentChoiceTwo: '', frCCParentNameTwo: '', frCCParentICPasportTwo: '', frParentCCAgeTwo: '', frCCParentStatusTwo: '', 
                frCCParentEmployTypeTwo: '', frCCParentOccupationTwo: '', frCCParentWorkAddrTwo: '', frCCParentIncomeTwo: '', frCCParentOtherIncomeTwo: ''},
        frSiblingStudy:[{SiblingName: '', Gender: '', Age: '', NameOfSchool: '', SrcFinSupport: '' }],
        frSiblingWorking:[{SiblingName: '', Gender: '', Age: '', Occupation: '', Income: '' }],        
        frCommunityCareInfo:{frCCHome: '', frCCAddr: '', frCCLeaderName: '', frCCPosition: '', frCCTel: '', frCCMobile: '', frCCEmail: ''}     
                                });
       
        app.setScholarshopChosen('');
        app.setOtherInfoHeader('');
        app.setOtherInfoHeader2('');
        app.setShowEssay(false);
        app.setShowContactReferee(false);
        app.setShowSports(false);
        app.setShowMusicBackground(false);
        app.setShowExtracurricular(false);
        app.setShowFamilyBackground(false);    
        app.setShowCommunityCC(false);
        app.setShowSupportingDocuments(false);
        app.setShowParentGuardian(false); 

        app.setProgrammeOffer([]);
        app.setprogrammmeChosen('');
        app.setIntakesNoOffer([]);
        app.setIntakeNoChosen('');   

        app.setShowSchRegisterStatus(false);

    }

    var utc = require("dayjs/plugin/utc");
    var timezone = require("dayjs/plugin/timezone");
    dayjs.extend(utc);
    dayjs.extend(timezone);

    const handleSubmit = async (event) => {

        const form = event.currentTarget;

        // check support documents must have files uploaad
        if(app.scholarshipChosen) {
            setInvalidMsg("valid");           
        }

        
        if (form.checkValidity() === false || validateStdInput() === false || invalidMsg === "invalid") {

            event.preventDefault();
            event.stopPropagation();
            window.scrollTo(0, 0);
        
            //console.log("invalidMsg>>>" + invalidMsg);
            //console.log("validateStdInput>>>>> " + validateStdInput());
            //console.log("checkValidity>>>>> " + form.checkValidity());
            if(document.querySelector('input:invalid') !== null)
                document.querySelector('input:invalid').focus();

        } else {

            event.preventDefault();
            event.stopPropagation();

            setMessage('Submitting your request, please do not close or navigate away');
            setShowSpinner(true);
            setShowCloseButton(false);
            setModalShow(true);
       
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' })
                
                .then(token => {                  
                    
                    let postvalues = {...app.inStdValues};
                    postvalues.captcha_token = token;
                    postvalues.captcha_action = 'submit';

                    app.onChangeInStdValues({...postvalues});


                    let data = new FormData();
                    data.append("postvalues", JSON.stringify(postvalues));
                    let Scholar = documents.[app.scholarshipChosen];

                    Object.values(Scholar).map((key,index) => {

       
                        if(IGNORE_SUPPORT_DOC.search(key) < 0) {                         

                            for(let f of app.documents.[key]) {
                                          
                                data.append((key + "[]"), f);
                                //console.log(f);
                            }
                            
                        }
                        return true;
                    });

                    fetch(apiURL + "/submission_new",{
                        method: "post",
                        body: data
                    })
                    .then(res => res.json())
                        .then(
                            (result) => {      
                                
                                if(result.status === 200) {
                                    app.setSubmissionID(result.app_id);
                        
                                    event.target.reset();
                                    handleReset(event);
                                    history.push('/thank-you');    

                                }else if(result.status === 219) {
                                    setMessage('Sorry you have already submitted this scholarship form.');
                                    setShowSpinner(false);
                                    setShowCloseButton(true);
                                } else if(result.status === 500) {
                                    setMessage('Your submission was unsuccessful***');
                                    setShowSpinner(false);
                                    setShowCloseButton(true);
                                }else {
                                    setMessage('Your submission was unsuccessful****');
                                    setShowSpinner(false);
                                    setShowCloseButton(true);
                                }

                            },
                            (error) => {
                            //console.log(error);
                            setMessage('Your submission was unsuccessful**');
                            setShowSpinner(false);
                            setShowCloseButton(true);
                            }
                        )


                }, (error) => {
                    //console.log(error);
                    setMessage('Your submission was unsuccessful, not ready');
                    setShowSpinner(false);
                    setShowCloseButton(true);
                })
            });


         }

        app.setValidate(true);
        
    };

    function CheckMinAndMaxLength(field, label, min, max, currmsg) {
        
        let errmsg = "";
        if (field.length <min || field.length > max) {
            let errmsg = "Length of the " + label + " should be at least " + min + " characers and no not more than " + max + " characters. Please Check.";
            

            currmsg.push(errmsg); 
            return errmsg;       
        } 
        return errmsg;
    }

    function validateStdInput() 
    {
        let status = 'true';        

        let currmsg = [];


        if(CheckMinAndMaxLength(InStdValues.frName.trim(), "Name", 3, 80, currmsg).length) status=false;        
        if(CheckMinAndMaxLength(InStdValues.frICPassport.trim(), "IC / Passport No.", 5, 30, currmsg).length) status= false;
        if(CheckMinAndMaxLength(InStdValues.frEmail.trim(), "Email", 5, 200, currmsg).length) status= false;
        if(CheckMinAndMaxLength(InStdValues.frMobileNo.trim(), "Mobile No.", 7, 30, currmsg).length) status= false;
        //if(CheckMinAndMaxLength(InStdValues.frHomeAddr.trim(), "Home Address", 5, 250, currmsg).length) status= false;

        if (InStdValues.frScholarship !== 'ACE' && InStdValues.frScholarship !== 'TSDSDJC') {
            if(CheckMinAndMaxLength(InStdValues.frHomeAddr.trim(), "Home Address", 5, 250, currmsg).length) status= false;
        }

        if(dayjs().tz("Asia/Kuala_Lumpur").diff(InStdValues.frDOB, 'years') < ADULT_AGE) {        
            if(CheckMinAndMaxLength(InStdValues.frPGConsentName.trim(), "Parent/ Guardian's Name", 3, 30, currmsg).length) status= false;
            if(CheckMinAndMaxLength(InStdValues.frPGConsentICPassport.trim(), "Parent/ Guardian's NRIC/ Passport No.", 5, 80, currmsg).length) status= false;
        }

        if(!InStdValues.frEmail.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{2,64}@[a-zA-Z0-9-]{2,}.[a-zA-Z0-9-]{2,}(?:\.[a-zA-Z0-9-]{2,})*$/)) {

            let errmsg = "Email address is not valid. Please check.";


            currmsg.push(errmsg);                       
        }

        if(!dayjs(InStdValues.frDOB).isValid()) {

            let errmsg = "Date Of Birth is not valid. Please Check.";

            currmsg.push(errmsg);                       
        }        



        let Scholar = documents.[app.scholarshipChosen];

        if(app.scholarshipChosen) {    
            Object.values(Scholar).map((key,index) => {
            
                let ctr = 0;
            
                if(IGNORE_SUPPORT_DOC.search(key) < 0) { 
                    
                    
                    if(typeof app.documents.[key] === "object") {
                    
                        for(let f of app.documents.[key]) {
                            //console.log(key + " filename: " + f.name + " (" + f.size + "bytes)");                    
                            ++ctr;
                        }
            
                        if(ctr < 1) {     

                            let errmsg = "There is missing support document(s) for " + DocumentType.[key] + ". Please include the supporting document(s).";
                            currmsg.push(errmsg);             
                            status= false;
                            
                        } else {
                            //console.log(">>>>all docs present... hopefully<<<<");
                        }
                    } else {

                        let errmsg = "There is missing support document(s) for " + DocumentType.[key] + ". Please include the supporting document(s).";
                        currmsg.push(errmsg);     
                        status= false;
            
                    }
                }
                return true;
            })
        }


         app.setError(currmsg);

         //console.log("insStdValues >>> " + JSON.stringify({...app.inStdValues}, null, "\t"));
         //console.log("errorMsg >>> " + currmsg);
         
        return status;
    }



    let currentdate = dayjs().tz("Asia/Kuala_Lumpur");
    let currentyear = currentdate.year();
    
    return (
        <>
        <Form className='scholar-form' noValidate validated={app.validate} onSubmit={handleSubmit}>
     
            <Form.Row >
              <Col xs={12} md={12} lg={12}>
              <Form.Group as={Col} controlId="formHeader">
              <h4>SUNWAY SCHOLARSHIPS & FINANCIAL AID 2026 APPLICATION FORM </h4>              
              </Form.Group>
              </Col>
            </Form.Row>

            <Notification
                modalShow={modalShow}
                setModalShow={setModalShow}                
                message={message}
                spinner={spinner}
                closeButton={closeButton}
                />
            <ShowErrorMsg errorMsg={app.error} invalidMsg={invalidMsg} />
            <Scholarship />
            <SchRegisterStatus />
            <Programme />
            <BasicInfo             
                setMessage = {setMessage}
                setShowSpinner = {setShowSpinner}
                setShowCloseButton = {setShowCloseButton}
                setModalShow = {setModalShow}
            />
            <Qualification />
            <OtherInfoHeader2 />
            <Extracurricular />
            <OtherInfoHeader />
            <Essay />
            <ContactReferee />
            <MusicBackground />
            <Sports />
            <FamilyBackground />

            

            <SupportDocument     
                invalidMsg={invalidMsg}
                setInvalidMsg={updInvalidMsgCB}
                 />

            <Declaration />
            <ParentGuardian />
            <TermsAndConditions />
                  
            <Button
              block
              variant="primary"
              type="submit"
              onClick={setModalShow}
            >
              <b>SUBMIT APPLICATION</b>
            </Button>

            <Button
              block
              variant="danger"
              type="button"
              onClick={handleReset} 
            >
              <b>RESET </b>
            </Button>
 
          </Form>   
        
        </>
    )
}